import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_MY_FAVORITES } from '../graphql/queries';
import Layout from '../components/Layout';
import AdCard from '../components/Ads/AdCard';
import { Card, Button, Row, Col, Spinner } from 'react-bootstrap';
import { Heart } from 'react-bootstrap-icons';

const Favorites: React.FC = () => {
  const { data, loading } = useQuery(GET_MY_FAVORITES);

  const favorites = data?.myFavorites || [];

  return (
    <Layout showSidebar={false}>
      <div className="container py-4">
        {/* Header */}
        <div className="mb-4">
          <h1>My Favorites</h1>
          <p className="text-muted">Ads you've saved for later</p>
        </div>

        {/* Content */}
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : favorites.length === 0 ? (
          <Card className="text-center py-5 bg-light border-0">
            <Card.Body>
              <Heart className="mb-3 text-muted" size={64} />
              <h2 className="h4 mb-2">No favorites yet</h2>
              <p className="text-muted mb-4">Start browsing and save ads you like</p>
              <Link to="/">
                <Button variant="primary">Browse Ads</Button>
              </Link>
            </Card.Body>
          </Card>
        ) : (
          <Row>
            {favorites.map((ad: any) => (
              <Col key={ad.id} xs={12} sm={6} lg={4} xl={3} className="mb-4">
                <AdCard ad={ad} isFavorite={true} />
              </Col>
            ))}
          </Row>
        )}
      </div>
    </Layout>
  );
};

export default Favorites;
